import React from "react";
import $ from 'jquery';
import Popper from 'popper.js';
import "./App.css";
import { Homepage } from "./containers/homepage";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

function App(props) {
  return <Homepage />;
}

export default App;
